var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"fixed":"top"}},[(_vm.loader)?_c('div',{staticClass:"overlay"},[_c('b-spinner',{staticClass:"loader",attrs:{"variant":"primary","label":"Spinning"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }